import React from "react";
import Link from "../Link";
import LinkWorkTo from "../Link/LinkWorkTo";

const Logo = ({ lightTheme }) => {
  return (
    <img
      src={lightTheme ? "/logo-white.png" : "/logo-black.png"}
      alt="O'Neil + Shirley Architecture"
      className="w-32 md:w-48 lg:w-56"
    />
  );
};

const Header = ({ menuIcon, lightTheme, location }) => {
  return (
    <div
      className={`fixed top-0 inset-x-0 h-hh flex items-center z-50 pointer-events-none ${
        lightTheme ? "text-white" : "text-black"
      }`}
    >
      <div className="w-full flex justify-between items-center px-ogs">
        {location.pathname === "/" ? (
          <h1>
            <Link
              aria-label="O'Neil + Shirley Architecture"
              className="block pointer-events-auto"
              to="/"
            >
              <Logo lightTheme={lightTheme} />
            </Link>
          </h1>
        ) : (
          <div>
            <Link
              aria-label="O'Neil + Shirley Architecture"
              className="block pointer-events-auto"
              to="/"
            >
              <Logo lightTheme={lightTheme} />
            </Link>
          </div>
        )}
        {menuIcon && (
          <LinkWorkTo
            aria-label="work"
            className="menu-icon pointer-events-auto"
            to="/work/"
          >
            <div className="menu-icon__el menu-icon__el--a" />
            <div className="menu-icon__el menu-icon__el--b" />
            <div className="menu-icon__el menu-icon__el--c" />
          </LinkWorkTo>
        )}
      </div>
    </div>
  );
};

export default Header;
